<template>
  <div class="jobDetail breadcrumbs-absolute aboutUs Disclaimer" :class="{'aboutUsPC':$store.state.innerWidth>768}">
    <div class="header jobPosingSearch row flexHeader flexHeaderJia200">
    <Breadcrumbs></Breadcrumbs>
        <div class="warp-mask"></div>
        <div class="job-containers-center col-sm-10 col-md-8 padLeft-0 padRight-0">
            <h1 class="Bold" :class="{'font-size-60':$store.state.innerWidth>768}"> {{$t('message.Privacy Policy')}}</h1>
        </div>
    </div>
    <div class="opp-contain row">
      <div class="about-pc marin-b-100">
        <div class="descriptionPC-right col-sm-12 col-md-12 padLeft-0 padRight-0" >
            <div class="contentGroup padding-b-50">
               <div class="page1" >
                 <div v-if="this.$store.state.language == 'en_US'">
                    <p>
                    The Government of the Hong Kong Special Administrative Region ("the Government") is concerned to ensure that all personal data submitted through talent.gov.hk (www.talent.gov.hk) (“talent.gov.hk") are handled in accordance with the relevant provisions of the Personal Data (Privacy) Ordinance.
                  </p>
                    <p>
                    The Government will record visits to talent.gov.hk without collecting any personal identifiable information of users. Such general statistics are collected for the compilation of statistical reports and the diagnosis of problems with or concerning computer systems to help improve talent.gov.hk.
                    </p>
                    <p>
                   For different purposes and at different times you may be invited to provide personal data to the Government through talent.gov.hk on a voluntary basis. Personal information may include name, telephone number, mailing address or e-mail address. The Government will specify the collection purpose and intended usage of your data when it invites you to provide such information and advise you how you may request access to or correction of the personal data provided.
                    </p>
                    <p>
                    Unless permitted or required by law, the Government will not disclose your personal data to any third parties without your prior consent.
                    </p>
                 </div>
                <div v-if="this.$store.state.language == 'zh_HK'">
                  <p>
                  香港特別行政區政府 (下稱「政府」) 會確保所有透過「talent.gov.hk」遞交的個人資料，均按照《個人資料(私隱)條例》 的有關條文處理。
                  </p>
                  <p>
                  政府會記錄使用者瀏覽「talent.gov.hk」的次數，但並不會收集任何足以辨識使用者身分的資料。所收集的瀏覽次數紀錄只會用於製作統計報告及調查電腦系統問題，以助政府改善「talent.gov.hk」的服務。
                  </p>
                  <p>
                  政府可能會於不同期間及為個別原因，邀請你自願提供個人資料。此等資料可能包括姓名、電話號碼、郵寄地址或電郵地址。政府邀請你提供資料時，會列明收集資料的目的和用途，並會告知你如何要求查閱或改正所提供的個人資料。
                  </p>
                  <p>
                  除非法律許可或有所規定，政府不會在未得到你的同意下透露你的個人資料予第三者。
                  </p>
                </div>
                 <div v-if="this.$store.state.language == 'zh_CN'">
                  <p>
                  香港特别行政区政府 (下称「政府」) 会确保所有透过「talent.gov.hk」递交的个人资料，均按照《个人资料(私隐)条例》 的有关条文处理。
                  </p>
                  <p>
                  政府会记录用户浏览「talent.gov.hk」的次数，但并不会收集任何足以辨识用户身分的数据。所收集的浏览次数纪录只会用于制作统计报告及调查计算机系统问题，以助政府改善「talent.gov.hk」的服务。
                  </p>
                  <p>
                  政府可能会于不同期间及为个别原因，邀请你自愿提供个人资料。此等数据可能包括姓名、电话号码、邮件地址或电邮地址。政府邀请你提供资料时，会列明收集数据的目的和用途，并会告知你如何要求查阅或改正所提供的个人资料。
                  </p>
                  <p>
                  除非法律许可或有所规定，政府不会在未得到你的同意下透露你的个人资料予第三者。
                  </p>
                </div>
                 
               </div>
               <img class="bgImg2 noSelect" v-if="$store.state.innerWidth<=1120" src="../images/deco-18.png" />
            </div>
        </div>
      </div>
      <img class="bgImg noSelect" v-if="$store.state.innerWidth>1120" src="../images/deco-18.png" />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  name:"privacyPolicy",
  data() {
    return {
        }
    },   
  props:[
  ],
  components: {
    Breadcrumbs,
  },
  created() {},
  methods: {
  },
  mounted() {
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message."+that.$route.meta.title)+' - talent.gov.hk - '+that.$i18n.t("message.Default Page Title");
    })

    this.$store.state.selectMenu = 0;
  }
};
</script>